import logRocket from '@/checkout-instore-legacy/utils/LogRocket'

import { useCustomConfig } from './useCustomConfig'

const INSTORE_CORE_LOGROCKET_ID = 'elax9y/instore-core'

export const useLogRocket = () => {
  useCustomConfig({
    onConfigLoaded: () => {
      logRocket.init(INSTORE_CORE_LOGROCKET_ID)
    },
  })
}
